import { useMemo } from "react";
import { useTranslation } from "react-i18next"

const useEntryType = () => {
  const { t } = useTranslation();
  const entryTypeTranslationMap = useMemo(() => ({
    'WHITE': t('white'),
    'BLACK': t('black'),
    'DENY': t('status_not_in_list'),
    'OWNER': t('owner'),
    'PRE_PAY': t('pre_pay'),
    'PAY': t('payment'),
    'PAID': t('paid'),
    'PAY_ERROR': t('pay_error'),
    'TG_GUEST': t('tg_guest'),
    'GUEST': t('guest'),
    'FREE': t('free'),
    'FREE_MINUTES': t('rate_scale_time_free'),
    'BILLING_NOT_FOUND': t('no_debt'),
    'BILL_NOT_PAID': t('billing_not_paid'),
    'SUBSCRIPTION':  t('abonement'),
    'ABONEMENT_PAID':  t('abonement_status_paid'),
    'ABONEMENT_NOT_PAID':  t('abonement_status_not_paid'),
  }), [t])
  
  const entryTypeStatus = (type) => {
    switch (type) {
      case 'WHITE':
      case 'OWNER':
      case 'PRE_PAY':
      case 'FREE':
      case 'FREE_MINUTES':
      case 'BILLING_NOT_FOUND':
      case 'PAID':
      case 'SUBSCRIPTION':
      case 'ABONEMENT_PAID':
      case 'TG_GUEST':
      case 'GUEST':
        return 'good'
      default:
        return 'bad'
    }
  }
  return {
    entryTypeTranslationMap,
    entryTypeStatus
  }
}
export default useEntryType